// extracted by mini-css-extract-plugin
export default {"teacherRow":"TeacherItem_teacherRow__D+2IX"};